import React from "react";
import { Box } from "@mui/material";
import ProductImage from "../ProductImage";

interface ProductImageGalleryProps {
  images: string[];
  title: string;
  selectedImage: number;
  onSelectImage: (index: number) => void;
  onZoom: () => void;
}

const ProductImageGallery: React.FC<ProductImageGalleryProps> = ({
  images,
  title,
  selectedImage,
  onSelectImage,
  onZoom,
}) => {
  return (
    <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 40%" }, pl: { md: 3 }, pr: { md: 2 } }}>
      <Box
        sx={{
          position: "sticky",
          top: 20,
          borderRadius: 2,
          overflow: "hidden",
          mb: { xs: 3, md: 0 },
          cursor: "zoom-in",
        }}
        onClick={onZoom}
      >
        <ProductImage
          src={images[selectedImage] || "/placeholder-product.png"}
          alt={title}
          sx={{
            width: "100%",
            height: { xs: 250, sm: 350, md: 400 },
            objectFit: "contain",
          }}
        />
      </Box>

      {images.length > 1 && (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            mt: 2,
            overflowX: "auto",
            pb: 1,
            "&::-webkit-scrollbar": {
              height: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "4px",
            },
          }}
        >
          {images.map((image, index) => (
            <ProductImage
              key={index}
              src={image}
              alt={`${title} ${index + 1}`}
              onClick={() => onSelectImage(index)}
              sx={{
                width: 80,
                height: 80,
                objectFit: "cover",
                borderRadius: 1,
                border:
                  selectedImage === index
                    ? "2px solid var(--primary-color)"
                    : "2px solid var(--border-primary)",
                cursor: "pointer",
                transition: "all 0.3s",
                "&:hover": {
                  borderColor: "var(--primary-color)",
                  transform: "scale(1.05)",
                },
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ProductImageGallery;